ceregoCommon.service("UploaderService", ['$rootScope', 'DebugHelper', ($rootScope, DebugHelper) ->
  $scope = $rootScope.$new()

  DebugHelper.register("UploaderService", $scope)

  _.assignIn $scope,
    scormUploader: {}
])
